import { BillAmountEntry, FieldName } from '@/state/state.types';

export const getBillSumationValues = (
  fields: Partial<Record<FieldName, string | number | boolean>> | undefined,
) => {
  try {
    const raw = fields?.[FieldName.bill_amount];
    const entries = (raw ? JSON.parse(String(raw)) : []) as BillAmountEntry[];
    const total = entries.reduce((sum, entry) => sum + entry.amt, 0);
    return { totalBillAmount: total, lowerBound: total * 0.3, upperBound: total * 0.8 };
  } catch {
    return { totalBillAmount: 0, lowerBound: 0, upperBound: 0 };
  }
};
